import React from 'react';
import './index.less';
import classnames from 'classnames';
import MonthPicker from '../../';
import { ABSButton } from '../../../ABSButton';
import { IMonthRangePickerProps } from '../../interface';

import { moment } from '../../../../utils/momentUtils';
import { setEndDatePickerValue, today, endMax } from '../../utils';
import RangePickerHelper from '../../helper/rangePickerHelper';
export interface IState {
  endOpen?: boolean;
}

class MonthRangePicker extends React.Component<IMonthRangePickerProps, IState> {
  private componentKey: number = Math.floor(Math.random() * 1000);

  private pickerHelper: RangePickerHelper = new RangePickerHelper();

  private todayDate = false;
  private todayDateStr = '';

  static defaultProps() {
    return {
      startPlaceholder: '起',
      endPlaceholder: '止'
    };
  }

  constructor(props: IMonthRangePickerProps) {
    super(props);
    this.pickerHelper.init(props, true);
    this.state = {
      endOpen: false
    };
  }

  renderPresent() {
    return (
      <div className="abs-range-month-picker-present">
        <ABSButton onClick={this.onClickPresent}>今天</ABSButton>
      </div>
    );
  }

  render() {
    const { title, required, desc, startValue, startDefaultValue, contentWidth, removeMarginBottom, isVertical, isFlex } = this.props;
    const {
      startPlaceholder,
      endPlaceholder,
      startRules,
      endRules,
    } = this.props;
    const { endValue, endDefaultValue } = this.props;

    this.todayDate = false;
    if (
      (endDefaultValue && endDefaultValue.toString() === endMax) ||
      (endValue && endValue.toString() === endMax) ||
      this.todayDateStr === endMax
    ) {
      this.todayDate = true;
    }

    const { endOpen } = this.state;

    const classes = classnames(
      'abs-range-month-picker',
      `abs-month-picker-${this.componentKey}`,
      { 'remove-margin-bottom': removeMarginBottom },
      { 'title-vertical': isVertical }
    );

    return (
      <div className={classes}>
        <MonthPicker
          ref={view => (this.pickerHelper.startPickerRef = view)}
          picker="month"
          title={title}
          required={required}
          desc={desc}
          requiredMsg="请选择开始月份"
          value={startValue}
          rules={startRules}
          removeMarginBottom={true}
          defaultValue={startDefaultValue}
          placeholder={startPlaceholder}
          disabledDate={this.pickerHelper.renderDisabledStart}
          onChange={this.onStartChange}
          contentWidth={contentWidth || 212}
          isFlex={isFlex}
        />
        <div className="range-horizontal-bar" />
        <MonthPicker
          ref={view => (this.pickerHelper.endPickerRef = view)}
          picker="month"
          required={required}
          requiredMsg="请选择截止月份"
          value={endValue}
          rules={endRules}
          removeMarginBottom={true}
          defaultValue={endDefaultValue}
          placeholder={endPlaceholder}
          disabledDate={this.pickerHelper.renderDisabledEnd}
          onSetToday={this.onSetToday}
          open={endOpen}
          renderExtraFooter={() => this.renderPresent()}
          onChange={this.onEndChange}
          onOpenChange={this.onEndOpenChange}
          contentWidth={contentWidth || 212}
          isFlex={isFlex}
        />
      </div>
    );
  }

  onStartChange = (date, dateString) => {
    const { onStartChange } = this.props;
    this.pickerHelper.onStartChange(date, dateString, onStartChange);
  };

  onEndChange = (date, dateString) => {
    this.todayDateStr = dateString;
    const { onEndChange } = this.props;
    this.pickerHelper.onEndChange(date, dateString, onEndChange);
    setEndDatePickerValue(dateString, this.componentKey);
  };

  onClickPresent = () => {
    this.setState({ endOpen: false }, () => {
      setEndDatePickerValue(today, this.componentKey);
      if (this.pickerHelper.endPickerRef) {
        this.todayDateStr = endMax;
        this.pickerHelper.endPicker = moment(endMax);
        this.pickerHelper.endPickerRef.setValue(moment(endMax));
      }
      this.todayDate = true;
    });
  };

  onEndOpenChange = open => {
    this.setState({ endOpen: open }, this.onSetToday);
  };

  onSetToday = () => {
    const endMonthPickerInput = document.querySelectorAll(
      `.abs-range-month-picker.abs-month-picker-${
        this.componentKey
      } .ant-calendar-picker-input`
    )[1] as HTMLInputElement;
    const beforeOpenPickerInputValue = endMonthPickerInput
      ? endMonthPickerInput.value
      : '';
    if (beforeOpenPickerInputValue === today || this.todayDate) {
      endMonthPickerInput.value = today;
    }
  };

  /**
   * 验证
   */

  validatorValue = () => this.pickerHelper.validatorValue();

  reset = () => this.pickerHelper.reset(this.props);

  getValue = () => this.pickerHelper.getValue();
}

export { IMonthRangePickerProps };

export default MonthRangePicker;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDatePicker/RangePicker/MonthRangePicker/index.tsx